var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcArticles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M354 197v18c0 28 22 51 49 54h188c29 0 52-21 55-49v-23h75c39 0 71 32 71 71v578c0 39-32 71-71 71H279c-39 0-71-32-71-71V268c0-39 32-71 71-71h75zm256 396H354c-20 0-36 16-36 36 0 18 13 33 31 35l5 1h256c20 0 36-16 36-36s-16-36-36-36zM464 449H354c-20 0-36 16-36 36 0 18 13 33 31 36h115c20 0 36-16 36-36s-16-36-36-36zm36-324c19 0 34 14 36 31l1 5h55c10 0 17 8 17 18v36c0 10-7 18-17 18H408c-9 0-17-8-17-18v-36c0-10 8-18 17-18h56c0-20 16-36 36-36z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArticles);
export default __webpack_public_path__ + "static/media/ic_articles.4b752189c88a9122e2a4ebb18f6ecaf0.svg";
export { ForwardRef as ReactComponent };